import { render, staticRenderFns } from "./PdvUserTimelineClose.vue?vue&type=template&id=b435150c&scoped=true"
import script from "./PdvUserTimelineClose.vue?vue&type=script&lang=js"
export * from "./PdvUserTimelineClose.vue?vue&type=script&lang=js"
import style0 from "./PdvUserTimelineClose.vue?vue&type=style&index=0&id=b435150c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b435150c",
  null
  
)

export default component.exports